export type QualityPreference = 'bio' | 'non-bio' | 'mix'

export type CountryLocale = {
  currency_code: string
  currency_symbol: string
  locale: string
}

export const STORE_DISPLAY_NAMES: Record<string, string> = {
  hofer: 'Hofer',
  lidl: 'Lidl',
  billa: 'Billa',
  spar: 'Spar',
  mpreis: 'MPreis',
  penny: 'Penny',
  unimarkt: 'Unimarkt',
  dm: 'dm',
  mueller: 'Müller',
  rewe: 'REWE',
  reweDe: 'REWE',
  edeka: 'Edeka',
  dmDe: 'dm DE',
  sparSi: 'Spar SI',
  muellerDe: 'Müller DE',
  checkers: 'Checkers',
  pick_n_pay: 'Pick n Pay',
  woolworths_za: 'Woolworths',
  spar_za: 'SPAR',
  spar_zw: 'SPAR',
  tm_pick_n_pay: 'TM Pick n Pay',
  bon_marche: 'Bon Marché',
  food_lovers_zw: "Food Lover's Market",
}

const CHAIN_TO_SLUG: Record<string, string> = {
  HOFER: 'hofer',
  ALDI: 'hofer',
  BILLA: 'billa',
  SPAR: 'spar',
  INTERSPAR: 'spar',
  LIDL: 'lidl',
  LIDL_AT: 'lidl',
  BIPA: 'bipa',
  MERKUR: 'mpreis',
  CHECKERS: 'checkers',
  PICK_N_PAY: 'pick_n_pay',
  WOOLWORTHS_ZA: 'woolworths_za',
  SPAR_ZA: 'spar_za',
  SPAR_ZW: 'spar_zw',
  TM_PICK_N_PAY: 'tm_pick_n_pay',
  BON_MARCHE: 'bon_marche',
  FOOD_LOVERS_ZW: 'food_lovers_zw',
}

export const COUNTRY_CURRENCY_MAP: Record<string, CountryLocale> = {
  AT: { currency_code: 'EUR', currency_symbol: '€', locale: 'de-AT' },
  DE: { currency_code: 'EUR', currency_symbol: '€', locale: 'de-DE' },
  FR: { currency_code: 'EUR', currency_symbol: '€', locale: 'fr-FR' },
  IT: { currency_code: 'EUR', currency_symbol: '€', locale: 'it-IT' },
  ES: { currency_code: 'EUR', currency_symbol: '€', locale: 'es-ES' },
  PT: { currency_code: 'EUR', currency_symbol: '€', locale: 'pt-PT' },
  NL: { currency_code: 'EUR', currency_symbol: '€', locale: 'nl-NL' },
  BE: { currency_code: 'EUR', currency_symbol: '€', locale: 'fr-BE' },
  IE: { currency_code: 'EUR', currency_symbol: '€', locale: 'en-IE' },
  FI: { currency_code: 'EUR', currency_symbol: '€', locale: 'fi-FI' },
  GR: { currency_code: 'EUR', currency_symbol: '€', locale: 'el-GR' },
  SI: { currency_code: 'EUR', currency_symbol: '€', locale: 'sl-SI' },
  SK: { currency_code: 'EUR', currency_symbol: '€', locale: 'sk-SK' },
  GB: { currency_code: 'GBP', currency_symbol: '£', locale: 'en-GB' },
  CH: { currency_code: 'CHF', currency_symbol: 'CHF', locale: 'de-CH' },
  SE: { currency_code: 'SEK', currency_symbol: 'kr', locale: 'sv-SE' },
  NO: { currency_code: 'NOK', currency_symbol: 'kr', locale: 'nb-NO' },
  DK: { currency_code: 'DKK', currency_symbol: 'kr', locale: 'da-DK' },
  PL: { currency_code: 'PLN', currency_symbol: 'zł', locale: 'pl-PL' },
  CZ: { currency_code: 'CZK', currency_symbol: 'Kč', locale: 'cs-CZ' },
  HU: { currency_code: 'HUF', currency_symbol: 'Ft', locale: 'hu-HU' },
  RO: { currency_code: 'RON', currency_symbol: 'lei', locale: 'ro-RO' },
  HR: { currency_code: 'EUR', currency_symbol: '€', locale: 'hr-HR' },
  RS: { currency_code: 'RSD', currency_symbol: 'din', locale: 'sr-RS' },
  UA: { currency_code: 'UAH', currency_symbol: '₴', locale: 'uk-UA' },
  RU: { currency_code: 'RUB', currency_symbol: '₽', locale: 'ru-RU' },
  TR: { currency_code: 'TRY', currency_symbol: '₺', locale: 'tr-TR' },
  US: { currency_code: 'USD', currency_symbol: '$', locale: 'en-US' },
  CA: { currency_code: 'CAD', currency_symbol: 'CA$', locale: 'en-CA' },
  MX: { currency_code: 'MXN', currency_symbol: '$', locale: 'es-MX' },
  BR: { currency_code: 'BRL', currency_symbol: 'R$', locale: 'pt-BR' },
  AR: { currency_code: 'ARS', currency_symbol: '$', locale: 'es-AR' },
  CO: { currency_code: 'COP', currency_symbol: '$', locale: 'es-CO' },
  CL: { currency_code: 'CLP', currency_symbol: '$', locale: 'es-CL' },
  PE: { currency_code: 'PEN', currency_symbol: 'S/', locale: 'es-PE' },
  VE: { currency_code: 'USD', currency_symbol: '$', locale: 'es-VE' },
  AE: { currency_code: 'AED', currency_symbol: 'AED', locale: 'ar-AE' },
  SA: { currency_code: 'SAR', currency_symbol: 'SAR', locale: 'ar-SA' },
  EG: { currency_code: 'EGP', currency_symbol: 'E£', locale: 'ar-EG' },
  MA: { currency_code: 'MAD', currency_symbol: 'MAD', locale: 'ar-MA' },
  IL: { currency_code: 'ILS', currency_symbol: '₪', locale: 'he-IL' },
  QA: { currency_code: 'QAR', currency_symbol: 'QR', locale: 'ar-QA' },
  KW: { currency_code: 'KWD', currency_symbol: 'KD', locale: 'ar-KW' },
  JO: { currency_code: 'JOD', currency_symbol: 'JD', locale: 'ar-JO' },
  LB: { currency_code: 'USD', currency_symbol: '$', locale: 'ar-LB' },
  ZA: { currency_code: 'ZAR', currency_symbol: 'R', locale: 'en-ZA' },
  NG: { currency_code: 'NGN', currency_symbol: '₦', locale: 'en-NG' },
  KE: { currency_code: 'KES', currency_symbol: 'KSh', locale: 'sw-KE' },
  GH: { currency_code: 'GHS', currency_symbol: 'GH₵', locale: 'ak-GH' },
  ET: { currency_code: 'ETB', currency_symbol: 'Br', locale: 'am-ET' },
  TZ: { currency_code: 'TZS', currency_symbol: 'TSh', locale: 'sw-TZ' },
  UG: { currency_code: 'UGX', currency_symbol: 'USh', locale: 'sw-UG' },
  RW: { currency_code: 'RWF', currency_symbol: 'RF', locale: 'rw-RW' },
  ZM: { currency_code: 'ZMW', currency_symbol: 'ZK', locale: 'en-ZM' },
  ZW: { currency_code: 'USD', currency_symbol: '$', locale: 'en-ZW' },
  MZ: { currency_code: 'MZN', currency_symbol: 'MT', locale: 'pt-MZ' },
  AO: { currency_code: 'AOA', currency_symbol: 'Kz', locale: 'pt-AO' },
  SN: { currency_code: 'XOF', currency_symbol: 'CFA', locale: 'fr-SN' },
  CI: { currency_code: 'XOF', currency_symbol: 'CFA', locale: 'fr-CI' },
  CM: { currency_code: 'XAF', currency_symbol: 'CFA', locale: 'fr-CM' },
  AU: { currency_code: 'AUD', currency_symbol: 'A$', locale: 'en-AU' },
  NZ: { currency_code: 'NZD', currency_symbol: 'NZ$', locale: 'en-NZ' },
  IN: { currency_code: 'INR', currency_symbol: '₹', locale: 'en-IN' },
  CN: { currency_code: 'CNY', currency_symbol: '¥', locale: 'zh-CN' },
  JP: { currency_code: 'JPY', currency_symbol: '¥', locale: 'ja-JP' },
  KR: { currency_code: 'KRW', currency_symbol: '₩', locale: 'ko-KR' },
  SG: { currency_code: 'SGD', currency_symbol: 'S$', locale: 'en-SG' },
  HK: { currency_code: 'HKD', currency_symbol: 'HK$', locale: 'zh-HK' },
  TW: { currency_code: 'TWD', currency_symbol: 'NT$', locale: 'zh-TW' },
  ID: { currency_code: 'IDR', currency_symbol: 'Rp', locale: 'id-ID' },
  TH: { currency_code: 'THB', currency_symbol: '฿', locale: 'th-TH' },
  PH: { currency_code: 'PHP', currency_symbol: '₱', locale: 'fil-PH' },
  VN: { currency_code: 'VND', currency_symbol: '₫', locale: 'vi-VN' },
  MY: { currency_code: 'MYR', currency_symbol: 'RM', locale: 'ms-MY' },
  PK: { currency_code: 'PKR', currency_symbol: '₨', locale: 'ur-PK' },
  BD: { currency_code: 'BDT', currency_symbol: '৳', locale: 'bn-BD' },
  LK: { currency_code: 'LKR', currency_symbol: 'Rs', locale: 'si-LK' },
  NP: { currency_code: 'NPR', currency_symbol: 'Rs', locale: 'ne-NP' },
}

export const CURRENCY_TO_COUNTRY: Record<string, string> = {
  EUR: 'AT',
  USD: 'US',
  GBP: 'GB',
  ZAR: 'ZA',
  AUD: 'AU',
  CAD: 'CA',
}

export function getCountryLocale(countryCode: string): CountryLocale {
  return COUNTRY_CURRENCY_MAP[countryCode.toUpperCase()] ?? {
    currency_code: 'USD',
    currency_symbol: '$',
    locale: 'en-US',
  }
}

export function detectBrowserCountryCode(): string {
  if (typeof navigator === 'undefined') return 'AT'
  const fromLang = navigator.language.split('-')[1]?.toUpperCase()
  if (fromLang && COUNTRY_CURRENCY_MAP[fromLang]) return fromLang
  return 'AT'
}

export function formatMoney(value: number, currencyCode = 'EUR', countryCode?: string, currencySymbol?: string): string {
  const locale = countryCode
    ? getCountryLocale(countryCode).locale
    : getCountryLocale(
        Object.entries(COUNTRY_CURRENCY_MAP).find(([, meta]) => meta.currency_code === currencyCode)?.[0] ?? 'AT',
      ).locale

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
    }).format(value)
  } catch {
    const symbol = currencySymbol ?? getCountryLocale(countryCode ?? 'AT').currency_symbol
    return `${symbol} ${value.toFixed(2)}`
  }
}

export function chainToStoreSlug(chain: string): string {
  return CHAIN_TO_SLUG[chain.toUpperCase()] ?? chain.toLowerCase()
}

export function toBackendQuality(pref: QualityPreference): 'bio_only' | 'balanced_mix' | 'budget_first' {
  if (pref === 'bio') return 'bio_only'
  if (pref === 'non-bio') return 'budget_first'
  return 'balanced_mix'
}

export function localeFromProfile(profile: Record<string, unknown>): { countryCode: string; currencyCode: string; currencySymbol: string } {
  const countryCode = String(profile.country_code ?? CURRENCY_TO_COUNTRY[String(profile.preferred_currency ?? 'EUR')] ?? 'AT').toUpperCase()
  const locale = getCountryLocale(countryCode)
  return {
    countryCode,
    currencyCode: String(profile.currency_code ?? locale.currency_code),
    currencySymbol: String(profile.currency_symbol ?? locale.currency_symbol),
  }
}
